import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class DesksLandingPageRoute extends Route {
  @service state;
  @service router;
  @service featureConfig;
  @service abilities;

  beforeModel() {
    if (this.abilities.cannot('visit-landing desks')) {
      this.router.transitionTo('unauthorized');
    }

    if (this.abilities.can('use generic resource')) {
      this.router.transitionTo('resources.resource-type.index', 1);
    }
  }

  model() {
    return this.modelFor('desks');
  }

  redirect({ floors }) {
    if (this.abilities.cannot('access desk')) return;
    if (!this.state.hasDesksAtLocation) return;
    if (!this.featureConfig.isEnabled('desks.accessDesksTab')) return;

    if (!floors.length) return this.router.transitionTo('desks.get-started');
    return this.router.transitionTo('desks.index');
  }
}
